import {
  ArrowLongLeftIcon,
  ArrowLongRightIcon,
} from "@heroicons/react/20/solid";
import Link from "next/link";

export default function PaginationComp({
  path,
  otherParams,
  currentPage,
  totalPages,
}: {
  path: string;
  otherParams: string;
  currentPage: number;
  totalPages: number;
}) {
  const maxVisible = 2;

  const getPages = () => {
    const pages: (number | string)[] = [];
    const startPage = Math.max(1, currentPage - maxVisible);
    const endPage = Math.min(totalPages, currentPage + maxVisible);

    if (startPage > 1) pages.push(1);
    if (startPage > 2) pages.push("...");

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    if (endPage < totalPages - 1) pages.push("...");
    if (endPage < totalPages) pages.push(totalPages);

    return pages;
  };

  return totalPages > 1 ? (
    <div className="flex items-center justify-between py-3 ">
      <div className="flex flex-1 justify-between">
        <Link
          href={
            currentPage > 1
              ? `${path}?page=${currentPage - 1}${otherParams}`
              : `${path}?page=1${otherParams}`
          }
          className={`relative inline-flex items-center gap-2 text-sm ${
            currentPage > 1 ? "hover:text-green" : "text-gray-300"
          } `}
        >
          <ArrowLongLeftIcon className="size-6" />
          <span>Sebelumnya</span>
        </Link>
        <nav
          aria-label="Pagination"
          className="isolate -space-x-px hidden lg:inline-flex"
        >
          {getPages().map((page) => (
            <Link
              key={page}
              href={page === "..." ? "#" : `${path}?page=${page}${otherParams}`}
              className={`relative inline-flex items-center px-4 py-2 text-sm hover:text-green ${
                currentPage === page
                  ? "border-t-2 border-solid border-green text-green"
                  : ""
              }`}
            >
              {page}
            </Link>
          ))}
        </nav>
        <Link
          href={
            currentPage < totalPages
              ? `${path}?page=${+currentPage + 1}${otherParams}`
              : `${path}?page=${totalPages}${otherParams}`
          }
          className={`relative inline-flex items-center gap-2 text-sm ${
            currentPage < totalPages ? "hover:text-green" : "text-gray-300"
          } `}
        >
          <span>Berikutnya</span>
          <ArrowLongRightIcon className="size-6" />
        </Link>
      </div>
    </div>
  ) : (
    <></>
  );
}
